import CertificateIcon from '../assets/certificate.svg'
import ClockIcon from '../assets/clock.svg'
import PeopleIcon from '../assets/people.svg'
import SparkleIcon from '../assets/sparkle.svg'
import type { CohortBenefit, CohortBenefitIcon } from '../types'

const ICONS = {
  sparkle: SparkleIcon,
  people: PeopleIcon,
  clock: ClockIcon,
  certificate: CertificateIcon,
} satisfies Record<CohortBenefitIcon, unknown>

export const CohortBenefits = ({ benefits }: { benefits: CohortBenefit[] }) => (
  <section className='container py-7 lg:py-8'>
    <ul className='m-0 flex list-none flex-col divide-y divide-dotted divide-c-base-900 rounded-xl bg-c-base-100 p-5 lg:flex-row lg:divide-x lg:divide-y-0'>
      {benefits.map(({ icon, title, description }) => {
        const Icon = ICONS[icon]

        return (
          <li
            key={title}
            className='flex flex-1 flex-col gap-4 py-5 first:pt-0 last:pb-0 lg:px-5 lg:py-0 lg:first:pl-0 lg:last:pr-0'
          >
            <span
              aria-hidden
              className='flex self-start rounded-sm bg-c-beige-300 p-1'
            >
              <span className='flex size-6 items-center justify-center'>
                <Icon />
              </span>
            </span>
            <div className='flex flex-col gap-3'>
              <h2 className='c-heading-5 m-0 text-c-text-dark'>{title}</h2>
              <p className='c-body m-0 text-c-text-tint-3'>{description}</p>
            </div>
          </li>
        )
      })}
    </ul>
  </section>
)
